module.exports = __webpack_public_path__ + "static/media/Logo_VM.f738efe5.jpg";